import APP_CONST from '../../constants';
import HoldingPage from './';
import { TokenManager } from '../../services';
import { ROUTER_CONST, $state } from '../../router';

export default {
    name: 'holding',
    url: '/holding?{code}',
    component: HoldingPage,
    layout: APP_CONST.LAYOUT_PARTIAL,
    visibility: ROUTER_CONST.STATE_VISIBILITY_PROTECTED,
    resolve: [{   
        token: 'check',
        deps: ['$transition$'],
        resolveFn: (trans) => {
            if (!trans.params().code || !TokenManager.hasTokens()) {
                $state.go('login');
                return false;
            }
            return true;
        }
    }]
};